import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IPosition} from '../types/portfolio'
import {IAsset} from './getKeyProfile'

export interface IKeyDetail {
    id: string
    user_id: string
    user: string
    name?: string
    exchange?: string
    access_key?: string
    is_active: true
    created_at?: number
    account_id: string
    risk?: number
    tpd?: number
    win?: number
    copying_key_id?: string
    copying_user_id?: string
    assets: IAsset[]
    positions: IPosition[]
    is_bot: boolean

    bybit_info?: BybitInfo
    binance_info?: BinanceInfo
    okx_info?: OkxInfo
}

export interface BinanceInfo {
    ipRestrict: boolean
    createTime: number
    enableReading: boolean
    enableSpotAndMarginTrading: boolean
    enableWithdrawals: boolean
    enableInternalTransfer: boolean
    enableMargin: boolean
    enableFutures: boolean
    permitsUniversalTransfer: boolean
    enableVanillaOptions: boolean
}

export interface OkxInfo {
    acctLv: string
    autoLoan: boolean
    ctIsoMode: string
    greeksType: string
    ip: string
    kycLv: string
    label: string
    level: string
    levelTmp: string
    liquidationGear: string
    mainUid: string
    mgnIsoMode: string
    opAuth: string
    perm: string
    posMode: string
    roleType: string
    spotOffsetType: string
    uid: string
}

export interface BybitInfo {
    id: string
    note: string
    apiKey: string
    readOnly: number // Generated by https://quicktype.io
    secret: string
    permissions: Permissions
    ips: string[]
    type: number
    deadlineDay: number
    expiredAt: string
    createdAt: string
    uta: number
    userID: number
    inviterID: number
    vipLevel: string
    mktMakerLevel: string
    affiliateID: number
    rsaPublicKey: string
    isMaster: boolean
}

export interface Permissions {
    ContractTrade: string[]
    Spot: string[]
    Wallet: string[]
    Options: string[]
    Derivatives: string[]
    CopyTrading: string[]
    BlockTrade: string[]
    Exchange: string[]
    NFT: string[]
}

export const getKey = async (keyId: string): Promise<ApiRes<IKeyDetail>> => {
    return await apiGet(API_URL, `admin/key/${keyId}`)
}
